<template>
  <a :href="link" class="card-btn-container">
    <div class="card-btn-top-content">
      <div class="card-btn-title">{{ title }}</div>
      <span class="card-btn-subtitle">{{ subtitle }}</span>
    </div>

    <div class="card-btn-bottom-content">
      <ForwardChevronIcon></ForwardChevronIcon>
    </div>
  </a>
</template>

<script>
import ForwardChevronIcon from '@icons/ForwardChevronIcon';

export default {
  components: { ForwardChevronIcon },

  props: {
    title: {
      required: true,
      type: String,
    },
    subtitle: {
      required: false,
      type: String,
      default: '',
    },
    link: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-btn-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 122px;
  border: 1px solid rgba(194, 194, 194, 0.7);
  border-radius: 4px;
  background-color: #fbfbfb;
  padding: 11px 14px;
}

.card-btn-top-content {
  display: flex;
  flex-direction: column;
}

.card-btn-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 4px;
}

.card-btn-subtitle {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16px;
}

.card-btn-bottom-content {
  width: 100%;
  text-align: right;
}
</style>
